import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, pairwise, startWith } from 'rxjs/operators';
import { BaseButtonSize } from '../button/base-button.component';
import { BaseUpToDateBuildService } from '../../../core/services/base-up-to-date.service';
import { BaseModalService } from '../../services/base-modal.service';

@Component({
  selector: 'base-up-to-date-app',
  templateUrl: './base-up-to-date.component.html',
})
export class BaseUpToDateComponent implements OnInit, OnDestroy {
  @ViewChild('refreshAppVersionTemplate', { static: true }) refreshAppVersionTemplate: ElementRef;

  buildIsUpToDate = true;
  isReloadRequired = false;
  buttonSizes = BaseButtonSize;

  private destroy$ = new Subject<boolean>();
  private isReloadModalOpen = false;

  constructor(private upToDateService: BaseUpToDateBuildService, private modalService: BaseModalService) {}

  ngOnInit(): void {
    this.upToDateService.buildIsUpToDate$.pipe(takeUntil(this.destroy$)).subscribe((isUpToDate) => {
      this.buildIsUpToDate = isUpToDate;
    });

    this.upToDateService.buildIsUpToDate$
      .pipe(startWith(true), pairwise(), takeUntil(this.destroy$))
      .subscribe(([previous, current]) => {
        if (previous === true && current === false) {
          if (!this.isReloadModalOpen) {
            this.isReloadModalOpen = true;
            this.showReloadModal();
          }
        }
      });

    this.upToDateService.isReloadRequired$.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.isReloadRequired = value;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  reloadPage(): void {
    location.reload();
  }

  private showReloadModal(): void {
    this.modalService
      .open(
        {
          headText: 'pageUpdate.title',
          bodyTemplate: this.refreshAppVersionTemplate,
          okText: 'pageUpdate.reloadNow',
          cancelText: 'pageUpdate.reloadLater',
        },
        {
          size: 'lg',
          backdrop: 'static',
        }
      )
      .result.then(
        () => {
          this.isReloadModalOpen = false;
          this.reloadPage();
          this.upToDateService.setIsReloadRequired(false);
        },
        () => {
          this.isReloadModalOpen = false;
          this.upToDateService.setIsReloadRequired(true);
        }
      );
  }
}
